export const addon_url: string = "addon";
